import { fetchEmojis, type Emoji } from 'emojibase';

const emojiDataPromises = new Map<string, Promise<Emoji[]>>();
type EmojiLocale = Parameters<typeof fetchEmojis>[0];

export function loadEmojiData(locale: string): Promise<Emoji[]> {
  const existingPromise = emojiDataPromises.get(locale);
  if (existingPromise) return existingPromise;

  const request = fetchEmojis(locale as EmojiLocale, {
    shortcodes: ['en/github'],
    version: '17',
  });
  const promise: Promise<Emoji[]> = request.catch(() =>
    locale === 'en'
      ? Promise.reject(new Error('Could not load emoji data'))
      : loadEmojiData('en'),
  );
  const cached = promise.catch((error: unknown) => {
    emojiDataPromises.delete(locale);
    throw error;
  });
  emojiDataPromises.set(locale, cached);
  return cached;
}

export function getTriggerRange(value: string, cursor: number) {
  const match = /(^|\s):([\p{L}\p{N}_+-]*)$/iu.exec(value.slice(0, cursor));
  return match
    ? {
        query: match[2] ?? '',
        start: cursor - match[0].length + (match[1]?.length ?? 0),
      }
    : null;
}
